import React from 'react';
import { getPaginationModel } from './paginationUtils';

const MealplanManager = ({ mealplans, onEdit, onDelete, searchTerm, onSearchChange, page, onPageChange, onSelect, selectedMealplan, unselectAllMealplans, isMealPlanDirty, searchInputRef }) => {
  const sortedMealplans = [...mealplans].sort((a, b) => a.title.localeCompare(b.title));
  const pageSize = 5;
  const totalPages = Math.ceil(sortedMealplans.length / pageSize);
  const paginatedMealplans = sortedMealplans.slice((page - 1) * pageSize, page * pageSize);
  const paginationModel = getPaginationModel(page, totalPages);

  const emptyRows = pageSize - paginatedMealplans.length;

  return (
    <div>
      {mealplans.length === 0 && searchTerm.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '1rem' }}>No meal plans saved.<br/>Select 1 or more recipes, place them in any order and save the meal plan using a descriptive name.</div>
      ) : (
        <>
        <div className="meal-plan-filter-controls" style={{ display: 'flex', alignItems: 'center' }}>
            {selectedMealplan.id > 0 && <button title="Unselect meal plan" onClick={unselectAllMealplans} className="unselect-button">Unselect</button>}
            <div className={`search-input-container expanded`}>
              <input
                ref={searchInputRef}
                type="text"
                placeholder="Search meal plans"
                value={searchTerm}
                onChange={e => onSearchChange(e.target.value)}
              />
              {searchTerm && <button onClick={() => { onSearchChange(''); searchInputRef.current.focus(); }} className="clear-input-button" title="Clear search"><i className="material-icons">close</i></button>}
            </div>
        </div>
        </>
      )}
      {paginatedMealplans.length === 0 && searchTerm.length > 0 ? (
        <div style={{ textAlign: 'center', padding: '1rem' }}>No meal plans found for "{searchTerm}".</div>
      ) : (
        <>
          <ul className="mealplan-list">
            {paginatedMealplans.map((mealplan) => (
              <li key={mealplan.id} onClick={() => {
                if (selectedMealplan && selectedMealplan.id === mealplan.id) {
                  unselectAllMealplans();
                } else {
                  onSelect(mealplan);
                }
              }} className={`mealplan-item ${selectedMealplan && selectedMealplan.id === mealplan.id ? 'selected' : ''}`}>
                {mealplan.title}
                <div className="item-actions">
                  <button onClick={(e) => { e.stopPropagation(); onEdit(mealplan); }} className="icon-button" title="Edit mealplan"><i className="material-icons">edit</i></button>
                  <button onClick={(e) => { e.stopPropagation(); onDelete(mealplan.id); }} className="icon-button delete-button" title="Delete mealplan"><i className="material-icons">delete</i></button>
                </div>
              </li>
            ))}
            {page === totalPages && emptyRows > 0 && [...Array(emptyRows)].map((_, index) => (
              <li key={`empty-${index}`} style={{ visibility: 'hidden' }}>
                &nbsp;
              </li>
            ))}
          </ul>
          {totalPages > 1 && (
            <div className="pagination-controls">
              <button onClick={() => onPageChange(page - 1)} disabled={page === 1} className="icon-button" title="Previous page"><i className="material-icons">keyboard_arrow_left</i></button>
              <div className="page-numbers">
                {paginationModel.map((item, index) => (
                  <button key={index} onClick={() => onPageChange(item)} disabled={item === '...' || item === page} className={item === page ? 'active' : ''} title={`Go to page ${item}`}>
                    {item}
                  </button>
                ))}
              </div>
              <button onClick={() => onPageChange(page + 1)} disabled={paginatedMealplans.length < pageSize || page * pageSize >= mealplans.length} className="icon-button" title="Next page"><i className="material-icons">keyboard_arrow_right</i></button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MealplanManager;